export default function Card(props) {
  let { children,  className, ...rest } = props;
  className = className || '';
  return (
    <div className={`card ${className}`} {...rest}>
      {children}
    </div>
  );
}